export default __webpack_public_path__ + "static/media/equivalent_copima.a1e6057d.svg";